import * as hosts from '../shared/constants/hosts';
import request from '../shared/request';
import {
  GetV1PrescriptionsElectronicsCanContinueListRequestParams,
  GetV1PrescriptionsElectronicsCanContinueListResponse,
} from './apis';

export interface PostV1ContinuePresApplyRequestBody {
  /**
   * 处方id
   */
  prescriptionId: number;
  /**
   * 来源 1-患者, 3-微信小程序
   */
  origin: number;
}
export interface PostV1ContinuePresApplyResponse {
  /**
   * 能否申请
   */
  canApply: boolean;
}
/**
 * 申请续方复购
 */
export const postV1ContinuePresApply = () => {
  return request.post<
    PostV1ContinuePresApplyRequestBody,
    PostV1ContinuePresApplyResponse
  >(`/prescription-interface/v1/prescription/continue/patient-apply`, {
    bodyType: 'json',
    baseURL: hosts.GENERAL,
  });
};

/**
 * 患者可续方的处方列表
 */
export const getV1PrescriptionsElectronicsCanContinueList = () => {
  return request.get<
    GetV1PrescriptionsElectronicsCanContinueListRequestParams,
    GetV1PrescriptionsElectronicsCanContinueListResponse
  >(`/prescription-interface/v1/prescription/electronic/con-continue/list`, {
    baseURL: hosts.GENERAL,
  });
};

export const PostCheckCreteEpc = () => {
  return request.post<{ prescriptionId: number }, { result: boolean }>(
    `/prescription-interface/v1/prescription/continue/check-create-epc`,
    {
      baseURL: hosts.GENERAL,
    }
  );
};
